import { useAsyncData } from 'shared/hooks/useAsyncData';
import { ARENA_KPIS } from 'modules/arena/dashboard/content';
import { fetchArenaKpis } from 'modules/arena/dashboard/dashboardService';

export function useArenaDashboard() {
  const { data: kpis, isLoading, error } = useAsyncData(fetchArenaKpis, ARENA_KPIS);
  return { kpis, isLoading, error };
}
